<template>
    <div class="catalogue">
        <uCatalogueItem :list="catalogueTree" :bookName="bookName" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

// import cs from './cs.js';
export default {
    computed: {
        ...mapGetters(["catalogueTree"])
    },
    props: {
        bookName: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
        }
    },
    methods: {
    },
    created() {
    },

}
</script>

<style lang="scss" scoped></style>